/* eslint-disable no-empty */
import { useEffect, useState } from 'react';
import { VegaSelectOption } from '../../../components/common/VegaSelect';
import VegaSelectWithCheckbox from '../../../components/common/VegaSelectWithCheckbox';

interface IProps {
  selected: any;
  onSelecte: (select: string) => void;
  onDelete: (select: number) => void;
}

const UserTypeSelector = ({ onSelecte, selected, onDelete }: IProps) => {
  const [page, setPage] = useState<number>(0);
  const [totalItem, setTotalItem] = useState<number>(0);
  const [users, setUsers] = useState<VegaSelectOption[]>([
    {
      label: 'RCM',
      value: 'RCM',
    },
    {
      label: 'CCM',
      value: 'CCM',
    },
    {
      label: 'ACM',
      value: 'ACM',
    },
  ]);

  const loadMoreItems = (event: any) => {
    if (
      event.target.scrollTop + event.target.clientHeight >=
      event.target.scrollHeight
    ) {
      if (totalItem !== users.length) {
        setPage(page + 1);
      }
    }
  };

  const getUserList = async () => {};

  useEffect(() => {
    getUserList();
  }, [page]);
  return (
    <VegaSelectWithCheckbox
      options={users}
      onSelect={selected => onSelecte(selected)}
      handleDelete={onDelete}
      selected={selected}
      placeHolder="Select user"
      onScroll={loadMoreItems}
    />
  );
};

export default UserTypeSelector;
